import { repApi } from './repApi';
import type { CapabilityTarget, MilestoneTemplate } from '@/types';

export const referenceApi = repApi.injectEndpoints({
  endpoints: (builder) => ({
    capabilityTargets: builder.query<CapabilityTarget[], void>({
      query: () => '/capability-targets',
      providesTags: ['CapabilityTarget'],
    }),
    getCapabilityTarget: builder.query<CapabilityTarget, number>({
      query: (id) => `/capability-targets/${id}`,
      providesTags: (_r, _e, id) => [{ type: 'CapabilityTarget', id }],
    }),
    createCapabilityTarget: builder.mutation<CapabilityTarget, Partial<CapabilityTarget>>({
      query: (body) => ({ url: '/capability-targets', method: 'POST', body }),
      invalidatesTags: ['CapabilityTarget'],
    }),
    updateCapabilityTarget: builder.mutation<
      CapabilityTarget,
      { id: number; body: Partial<CapabilityTarget> }
    >({
      query: ({ id, body }) => ({ url: `/capability-targets/${id}`, method: 'PUT', body }),
      invalidatesTags: (_r, _e, { id }) => ['CapabilityTarget', { type: 'CapabilityTarget', id }],
    }),
    deleteCapabilityTarget: builder.mutation<{ pvDataID: number }, number>({
      query: (id) => ({ url: `/capability-targets/${id}`, method: 'DELETE' }),
      invalidatesTags: ['CapabilityTarget'],
    }),
    milestoneTemplates: builder.query<MilestoneTemplate[], void>({
      query: () => '/milestones',
      providesTags: ['Milestone'],
    }),
    getMilestoneTemplate: builder.query<MilestoneTemplate, number>({
      query: (id) => `/milestones/${id}`,
      providesTags: (_r, _e, id) => [{ type: 'Milestone', id }],
    }),
    createMilestoneTemplate: builder.mutation<MilestoneTemplate, Partial<MilestoneTemplate>>({
      query: (body) => ({ url: '/milestones', method: 'POST', body }),
      invalidatesTags: ['Milestone'],
    }),
    updateMilestoneTemplate: builder.mutation<
      MilestoneTemplate,
      { id: number; body: Partial<MilestoneTemplate> }
    >({
      query: ({ id, body }) => ({ url: `/milestones/${id}`, method: 'PUT', body }),
      invalidatesTags: (_r, _e, { id }) => ['Milestone', { type: 'Milestone', id }],
    }),
    deleteMilestoneTemplate: builder.mutation<{ pvDataID: number }, number>({
      query: (id) => ({ url: `/milestones/${id}`, method: 'DELETE' }),
      invalidatesTags: ['Milestone'],
    }),
  }),
});

export const {
  useCapabilityTargetsQuery,
  useGetCapabilityTargetQuery,
  useCreateCapabilityTargetMutation,
  useUpdateCapabilityTargetMutation,
  useDeleteCapabilityTargetMutation,
  useMilestoneTemplatesQuery,
  useGetMilestoneTemplateQuery,
  useCreateMilestoneTemplateMutation,
  useUpdateMilestoneTemplateMutation,
  useDeleteMilestoneTemplateMutation,
} = referenceApi;
